module.exports = __webpack_public_path__ + "static/media/LV.34fc5c8e.svg";